import React from 'react'
import store from '@/redux/store'
import RedirectModal from '@/modules/banking/components/redirect-modal'
import { TransactionCanceled } from '@/modules/banking/errors'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openRedirectModal = ({ transaction, onSuccess, onError, onAbort = () => { } }) => {
  const { transactionId } = transaction

  return new Promise((resolve, reject) => {
    const getComponent = (close) => {
      return (
        <div data-transaction-id={transactionId}>
          <RedirectModal
            open={true}
            store={store}
            transaction={transaction}
            onSuccess={(data) => {
              close()
              onSuccess(data)
              resolve(data)
            }}
            onError={(error) => {
              close()
              onError(error)
              reject(error)
            }}
            onAbort={() => {
              close()
              onAbort()
              reject(new TransactionCanceled(transaction))
            }}
          />
        </div>
      )
    }

    renderElement(getComponent)
  })
}

export default openRedirectModal
